export const goToService = (uuid) => {
  if (!uuid) return;

  window.open(
    `${window.location.origin}/#/dashboard/service/${uuid}`,
    "_blank",
  );
};
